// the keys in the map are irrelevant for code, its more so people know which team IDs they
// represent in staging
export const teamsAllowedToAccessProductionFromStaging = new Map([
    ['Big Datr - Customer Reports', '8c8a20a9-8824-4737-b1d1-114fe5f20096'],
    ['Big Datr - Developers', 'b3fe71d3-0620-4fae-927f-29bc0feb4d09'],
    ['Big Datr - Test Permissions', 'cebcdc9c-5fd1-4c43-9b40-922d135790d0']
]);

// same key as in `useGetPointingStagingToProductionData.ts` in client-main
export const pointToProductionLocalStorageKey = 'bd-app-pointToProductionOnStaging';
